// Native browser scrolling: no wheel hijacking, no artificial Lenis easing.
export function initSmoothScroll() { return undefined; }
export function destroySmoothScroll() { return undefined; }
export function scrollTopImmediate() { window.scrollTo({top:0,left:0,behavior:'auto'}); }
export function scrollToElement(target,{offset=0}={}) {
  if(!target) return;
  const top=target.getBoundingClientRect().top+window.scrollY+offset;
  window.scrollTo({top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
